import styles from "./styles.scss";
import { FC, PointerEventHandler, useRef } from "react";
import clsx from "clsx";
import { Cross, Search } from "@/assets/icons";
import { SearchFieldProps, SearchFieldType, SearchFieldVariant } from "./types";

export const SearchField: FC<SearchFieldProps> = ({
  className,
  value,
  onClear,
  placeholder = "Search...",
  type = SearchFieldType.White,
  variant = SearchFieldVariant.Large,
  clearButtonClassName,
  onIconClick,
  ...props
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleIconClick = () => {
    if (onIconClick) {
      onIconClick();
    } else {
      inputRef.current?.focus();
    }
  };

  const handlePointerDown: PointerEventHandler<HTMLButtonElement> = event => {
    event.preventDefault();
  };

  const handleClearButtonClick = () => {
    if (onClear) {
      onClear();
    }
  };

  return (
    <div
      className={clsx(
        styles.container,
        styles[type],
        styles[variant],
        className,
      )}
    >
      <Search
        className={clsx(styles.searchIcon, onIconClick && styles.clickable)}
        onClick={handleIconClick}
      />
      <input
        ref={inputRef}
        type="text"
        {...props}
        value={value}
        placeholder={placeholder}
        className={styles.textInput}
      />
      {onClear && value && (
        <button
          type="button"
          className={clsx(styles.clearButton, clearButtonClassName)}
          onPointerDown={handlePointerDown}
          onClick={handleClearButtonClick}
        >
          <Cross />
        </button>
      )}
    </div>
  );
};
